import AuthLayout from '@/modules/auth/layout/AuthLayout.vue';

const routes = [
  {
    path: 'auth/',
    name: 'auth',
    meta: {
      requiresAuth: false
    },
    redirect: {
      name: 'login'
    },
    component: AuthLayout,
    children: [
      {
        path: 'login',
        name: 'login',

        component: () => import('@/modules/auth/views/LoginPage.vue')
      },
      {
        path: 'forgot/password/:token',
        name: 'forgot-password',

        component: () =>
          import('@/modules/auth/views/ForgetPasswordTokenVerificationPage.vue')
      },
      {
        path: '2fa',
        name: '2fa',

        component: () => import('@/modules/auth/views/TwoFactor.vue')
      }
    ]
  }
];

export default routes;
